
const fn = i18n => app => (lngs, ns, key, fallbackValue, updateMissing, options) => {
  const missingKey = options._count ? key : options._key
  i18n.services.backendConnector.backend.create(lngs, ns, missingKey, fallbackValue)
}

export default fn
